module.exports = __webpack_public_path__ + "static/img/goodImages2.cc8e21c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/goodImages2.png
// module id = Qjak
// module chunks = 3